import type { IconTypes } from "solid-icons";

export const TbStackPlus: IconTypes = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    {...props}
  >
    <path d="M7 9.5L4 11L12 15L20 11L17 9.5" />
    <path d="M4 15L12 19L20 15" />
    <path d="M9 7H15" />
    <path d="M12 4V10" />
  </svg>
);
